import React from "react";
import { connect } from 'react-redux'
// import ninehImg from '@/assets/images/900.jpg'
// import hhImg from '@/assets/images/hh.png'
// import tgImg from '@/assets/images/tg.png'
// import qxImg from '@/assets/images/qx.png'
// import ymImg from '@/assets/images/ym.png'
// import yyImg from '@/assets/images/yy.png'
// import sdImg from '@/assets/images/sd.png'
// import fcImg from '@/assets/images/fc.png'
// import fzxImg from '@/assets/images/fc.png'
import { setTit } from '@/utils/settit'
import config from "@/config";
import './index.scss'
const mapStateToProps = (state) => ({
  tenant: state.getIn(['tenantReducer', 'tenant'])
})

const ForddTopTit = (props) => {
  // let {tenant} = props
  return (
    <p className="fordd-top-title">
      <img src={config.LOGO_IMG} alt=""/>
      {/* <img src={
        window.location.href.indexOf('tgh5') > -1 ? tgImg :
          (window.location.href.indexOf('hhh5') > -1 ? hhImg : (
            window.location.href.indexOf('jbh5') > -1 ? ninehImg : (
              window.location.href.indexOf('qxh5') > -1 ? qxImg: (
                window.location.href.indexOf('ymh5') > -1 ? ymImg : (
                  window.location.href.indexOf('yyh5') > -1 ? yyImg : (
                    window.location.href.indexOf('sdh5') > -1 ? sdImg:(
                      window.location.href.indexOf('fch5') > -1 ? fcImg:(
                        window.location.href.indexOf('fzxh5') > -1 ? fzxImg:'' 
                      ) 
                    )
                  )
                )
              )
            )
          ))
      } alt="" /> */}
      本次服务由「{setTit()}」为您提供
    </p>
  )
}
export default connect(mapStateToProps)(ForddTopTit)
